import type { AdsAssistantSocialPostRow } from "@/lib/adsAssistantClient";

export function excerpt(text: string, max = 100) {
  const t = text.replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max)}…`;
}

export function formatPublished(iso: string) {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export function analysisHints(post: AdsAssistantSocialPostRow): { summary: string; flags: string[]; tags: string[] } {
  const la = post.latest_analysis;
  const result = la?.result;
  if (!result || typeof result !== "object") return { summary: "", flags: [], tags: [] };
  const r = result as Record<string, unknown>;
  const summary = typeof r.ai_summary === "string" ? r.ai_summary : "";
  const flags = Array.isArray(r.compliance_flags)
    ? r.compliance_flags.filter((x): x is string => typeof x === "string")
    : [];
  const tags = Array.isArray(r.tags) ? r.tags.filter((x): x is string => typeof x === "string") : [];
  return { summary: excerpt(summary, 140), flags: flags.slice(0, 6), tags: tags.slice(0, 8) };
}
